import { RootState } from 'store/store';

export const getSurveyInviteVisible = (s: RootState) => s.surveyInvite.show;
export const getSurveyInviteLoading = (s: RootState) => s.surveyInvite.loading;
export const getSurveyInviteResolved = (s: RootState) => s.surveyInvite.resolved;
